import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8141be2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "text-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Release Notes", -1))
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.markdownArray, (markdown) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "releaseNote",
          key: markdown.version,
          innerHTML: markdown.note
        }, null, 8, _hoisted_4))
      }), 128))
    ])
  ]))
}